module.exports = __webpack_public_path__ + "static/media/map_dot_layer.01a49f3f.svg";